import { useState } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { usePatients } from '../../hooks/usePatient'
import Pacientes from './Pacientes'
import PacienteDetalle from './PacienteDetalle'
import Alertas from './Alertas'
import Dashboard from './Dashboard'
import { T, fonts } from '../../styles/theme'
import GestionUsuarios from './GestionUsuarios'
import CambiarPassword from '../../components/CambiarPassword'
import ExportModal from '../../components/ExportModal'
import { SectionLabel, Button } from '../../components/ui'
import { fetchPacientesParaExportacionAdmin } from '../../services/adminService'

const NAV = [
  { key: 'pacientes', icon: '👥', label: 'Pacientes' },
  { key: 'alertas', icon: '🔔', label: 'Alertas' },
  { key: 'dashboard', icon: '📊', label: 'Dashboard' },
  { key: 'perfil', icon: '⚙️', label: 'Perfil' },
]

export default function ProApp() {
  const { user, userRole, signOut } = useAuth()
  const esAdmin = userRole === 'admin'
  const { patients, loading, refetch, eliminarPaciente, fetchPatientHistory } = usePatients(user?.id)
  const [tab, setTab] = useState('pacientes')
  const [selectedId, setSelectedId] = useState(null)
  const [showGestion, setShowGestion] = useState(false)
  const [adminExportPatients, setAdminExportPatients] = useState(null)
  const [showAdminExport, setShowAdminExport] = useState(false)
  const [loadingAdminExport, setLoadingAdminExport] = useState(false)

  const selected = patients.find(p => p.id === selectedId)

  if (showGestion) return (
    <GestionUsuarios onBack={() => setShowGestion(false)} esAdmin={esAdmin} />
  )

  async function abrirExportacionAdmin() {
    setLoadingAdminExport(true)
    const lista = await fetchPacientesParaExportacionAdmin(user.id)
    setAdminExportPatients(lista)
    setLoadingAdminExport(false)
    setShowAdminExport(true)
  }

  if (selectedId && selected) return (
    <PacienteDetalle
      patient={selected}
      onBack={() => setSelectedId(null)}
      refetch={refetch}
      profesionalId={user?.id}
      eliminarPaciente={eliminarPaciente}
      fetchPatientHistory={fetchPatientHistory}
    />
  )

  const allAlerts = patients.flatMap(p => p.alerts.map(a => ({ ...a, paciente: p.nombre, pacienteId: p.id })))

  return (
    <>
      <style>{`
        ${fonts}
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${T.bg}; font-family: 'DM Sans', sans-serif; }
        ::-webkit-scrollbar { width: 3px; }
        ::-webkit-scrollbar-thumb { background: ${T.cardB}; border-radius: 2px; }
      `}</style>
      <div style={{ maxWidth: 390, margin: '0 auto', minHeight: '100vh', background: T.bg, position: 'relative' }}>
        <div style={{ paddingBottom: 80, overflowY: 'auto', minHeight: '100vh' }}>

          {tab === 'pacientes' && (
            <Pacientes
              patients={patients}
              loading={loading}
              onSelect={setSelectedId}
              onSignOut={signOut}
              onNuevoUsuario={() => setShowGestion(true)}
              profesionalId={user?.id}
              refetch={refetch}
            />
          )}
          {tab === 'alertas' && <Alertas alerts={allAlerts} onSelect={setSelectedId} />}
          {tab === 'dashboard' && <Dashboard patients={patients} />}
          {tab === 'perfil' && (
  <div>
    <div style={{ padding: '52px 20px 12px' }}>
      <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5 }}>Mi perfil</div>
      <div style={{ fontSize: 13, color: T.muted, marginTop: 2 }}>Configuración de cuenta</div>
    </div>
    <SectionLabel>
      Seguridad
    </SectionLabel>
    <div style={{ background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 16, padding: 16, margin: '0 16px 12px' }}>
      <CambiarPassword />
    </div>

    {esAdmin && (
      <>
        <SectionLabel>
          Exportación para estudios
        </SectionLabel>
        <div style={{ background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 16, padding: 16, margin: '0 16px 12px' }}>
          <div style={{ fontSize: 13, color: T.sub, marginBottom: 12, lineHeight: 1.5 }}>
            Exporta en un único archivo los pacientes de todas las profesionales que has dado de alta, con opción de anonimizar.
          </div>
          <Button onClick={abrirExportacionAdmin} disabled={loadingAdminExport}>
            {loadingAdminExport ? 'Cargando pacientes...' : 'Exportar pacientes de mis profesionales'}
          </Button>
        </div>
      </>
    )}

    <button onClick={signOut} style={{
      display: 'block', margin: '0 16px', width: 'calc(100% - 32px)',
      padding: 14, borderRadius: 14, background: 'transparent',
      color: T.muted, fontSize: 15, fontWeight: 600,
      border: `1px solid ${T.cardB}`, cursor: 'pointer', fontFamily: 'DM Sans'
    }}>
      Cerrar sesión
    </button>
  </div>
)}

        </div>

        {esAdmin && (
          <ExportModal
            patients={adminExportPatients ?? []}
            open={showAdminExport}
            onClose={() => setShowAdminExport(false)}
          />
        )}

        <nav style={{
          position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
          width: 390, maxWidth: '100%', background: 'rgba(26,29,39,0.96)',
          backdropFilter: 'blur(12px)', borderTop: `1px solid ${T.cardB}`,
          display: 'flex', padding: '8px 0 20px', zIndex: 30
        }}>
          {NAV.map(({ key, icon, label }) => (
            <div key={key} onClick={() => setTab(key)} style={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
              gap: 3, cursor: 'pointer', padding: '6px 0'
            }}>
              <span style={{ fontSize: 20 }}>{icon}</span>
              <span style={{ fontSize: 10, fontWeight: 500, color: tab === key ? T.accent : T.muted }}>{label}</span>
              {tab === key && <div style={{ width: 4, height: 4, borderRadius: 2, background: T.accent }} />}
            </div>
          ))}
        </nav>
      </div>
    </>
  )
}